module.exports = __webpack_public_path__ + "static/media/search_diy.cfe52ac7.svg";